export const HEADER_HEIGHT = 40;

export const ALL_HOURS = Array.from({ length: 24 }, (_, index) => index);

export const DEFAULT_HOURS = Array.from({ length: 11 }, (_, index) => 8 + index);

export const DEFAULT_SETTINGS = {
  cellOpacity: 0.5,
  cellTextSize: 11,
  cellTextColor: "#ffffff",
  cellTextShadow: true,
  cellTimeTextSize: 11,
  dayTimeTextSize: 13,
  dayTimeTextColor: "#ffffff",
  dayTimeOpacity: 1,
  dayTimeTextShadow: true,
};

export const DEFAULT_CELL_COLOR = "#c2d3f3";
